import styled, { css } from "styled-components";

export const Container = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: #2125294f;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  z-index: 100;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const Button = styled.button`
  width: 100%;
  height: 60px;
  border: none;
  background: blue;
  color: #ffff;
  font-weight: bold;
  font-size: 22px;
`;

type ImgBannerProps = {
  isLink?: boolean;
  customWidth?: string;
  customHeight?: string;
};

export const ImgBanner = styled.img<ImgBannerProps>`
  width: ${({ customWidth }) => customWidth || "400px"};
  height: ${({ customHeight }) => customHeight || "400px"};

  @media (max-width: 600px) {
    width: 400px;
    height: 400px;
  }

  ${({ isLink }) =>
    isLink &&
    css`
      cursor: pointer;
    `}
`;

export const CloseContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const ButtonClose = styled.button`
  font-size: 26px;
  font-weight: bold;
  border: none;
  width: 45px;
  height: 45px;
  color: #ffff;
  background: transparent;
  cursor: pointer;
  outline: unset !important;
  margin-top: 24px;
`;

export const TextWrapper = styled.div`
  background-color: #000fff;
  padding: 24px;
  max-width: 532px;
  border: 2px solid #000fff;
`;

export const TextTitle = styled.h1`
  color: #00efff;
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  font-family: "Mangueira", sans-serif;
`;

export const TextSubTitle = styled.p`
  color: #ffffff;
  margin-top: 18px;
  text-align: center;
  font-size: 21px;
  font-family: "Mangueira", sans-serif;
  font-weight: 600;
`;

export const ButtonNPSContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonNPS = styled.button`
  border: none;
  background: #00efff;
  color: #000fff;
  font-weight: bold;
  font-size: 14px;
  border-radius: 8px;
  padding: 10px 26px;

  &:hover {
    filter: brightness(0.9);
  }
`;
